const StatusTabs = ({ statuses, activeTab, setActiveTab, collection }) => {
  return (
    <div className="status-tabs">
      {statuses.map(status => (
        <button
          key={status.key}
          onClick={() => setActiveTab(status.key)}
          className={`status-tab ${activeTab === status.key ? 'active' : ''}`}
        >
          <span>{status.label} </span>
        </button>
      ))}
    </div>
  );
};
// ({collection[status.key]?.length || 0})
export default StatusTabs;